import { Injectable, signal } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  // private loaderSubject: Subject<{ loading: boolean }> = new Subject<{ loading: boolean }>();
  // loaderState = this.loaderSubject.asObservable();

  loaderState = signal(false);

  show() {
    this.loaderState.set(true);
  }

  hide() {
    this.loaderState.set(false);
  }
}
